import {NgbModalOptions} from '@ng-bootstrap/ng-bootstrap';

export const DEAL_PAYROLL_USER_SETTINGS_HTTP_STATUS = {
  CONFLICT: 409,
  FORBIDDEN: 403
};

export const DEAL_PAYROLL_USER_SETTINGS_INITIAL_SEQUENCE = 0;
export const DEAL_PAYROLL_USER_REVISION_CONFLICT = 'USER_REVISION_CONFLICT';

export const DEAL_PAYROLL_USER_SETTINGS_ERROR_KEY = {
  NONE: '',
  LOAD: 'PAYROLL_CALCULATION_SETTINGS_LOAD_ERROR',
  SAVE: 'PAYROLL_CALCULATION_SETTINGS_SAVE_ERROR',
  FORBIDDEN: 'PAYROLL_CALCULATION_SETTINGS_FORBIDDEN',
  STALE: 'PAYROLL_CALCULATION_SETTINGS_STALE',
  USER_STALE: 'PAYROLL_CALCULATION_USER_STALE'
};

export const DEAL_PAYROLL_USER_SETTINGS_FEEDBACK_KEY = {
  NONE: '',
  LOADING: 'PAYROLL_CALCULATION_SETTINGS_LOADING',
  SAVING: 'PAYROLL_CALCULATION_SETTINGS_SAVING',
  SAVED: 'PAYROLL_CALCULATION_SETTINGS_SAVED'
};

export const DEAL_PAYROLL_ASSIGNMENT_WARNING_MODAL_OPTIONS: NgbModalOptions = {
  backdrop: 'static',
  keyboard: false
};



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/views/view-user-profile/deal-payroll-user-settings/deal-payroll-user-settings.constants.ts